var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#001B53",
    fillOpacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "uckg2bx66a",
    d: "M10 1.667C5.4 1.667 1.667 5.4 1.667 10S5.4 18.333 10 18.333 18.333 14.6 18.333 10 14.6 1.667 10 1.667zm.833 14.166H9.167v-1.666h1.666v1.666zm1.725-6.458l-.75.767c-.416.425-.716.808-.866 1.408-.067.267-.109.567-.109.95H9.167v-.417c0-.383.066-.75.183-1.091.167-.484.442-.917.792-1.267l1.033-1.05c.383-.367.567-.917.458-1.5-.108-.6-.575-1.108-1.158-1.275-.925-.258-1.783.267-2.058 1.058-.1.309-.359.542-.684.542h-.25c-.483 0-.816-.467-.683-.933.358-1.225 1.4-2.159 2.692-2.359 1.266-.2 2.475.459 3.225 1.5.983 1.359.691 2.817-.159 3.667z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoQuestionMark);
export default __webpack_public_path__ + "static/media/info-question-mark.b26ebe39d972b7d4181bc33e53523214.svg";
export { ForwardRef as ReactComponent };